// HeaderCN.jsx  (KO Header.jsx와 동일 로직/구조, 텍스트만 중국어로 번역)
// ✅ 다른거 수정하지 않음: 링크 경로/로직/클래스명 그대로
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectAuth, hydrateFromStorage } from "../pages/Auth/slice";
import { useEffect, useMemo, useRef, useCallback, useState } from "react";

function IconHamburger({ className = "" }) {
  return (
    <svg className={className} width="26" height="26" viewBox="0 0 26 26" aria-hidden="true" focusable="false">
      <path d="M4 6h16M4 12h16M4 18h16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function IconClose({ className = "" }) {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M6 6L18 18M18 6L6 18" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

export default function HeaderCN() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user: userFromStore } = useSelector(selectAuth);

  const utilRef = useRef(null); // .util (pc menu wrap)
  const navRef = useRef(null); // nav (pc gnb hover 기준)
  const moWrapRef = useRef(null); // .mo_menu_wrap (mobile menu)
  const moOpenIdxRef = useRef(-1); // 현재 열린 mobile depth2 index

  const [moOpen, setMoOpen] = useState(false);

  // ===== 모바일 depth2 슬라이드 유틸 =====
  const slideOpen = useCallback((el) => {
    if (!el) return;
    el.classList.add("is-open");
    el.style.maxHeight = el.scrollHeight + "px";
  }, []);

  const slideClose = useCallback((el) => {
    if (!el) return;
    el.classList.remove("is-open");
    el.style.maxHeight = "0px";
  }, []);

  const closeMenu = useCallback(() => {
    utilRef.current?.classList.remove("active");
    navRef.current?.classList.remove("active");

    if (moWrapRef.current) {
      moWrapRef.current.classList.remove("active");
      const depth2s = moWrapRef.current.querySelectorAll(".mo_menu_depth2");
      depth2s.forEach((el) => {
        el.classList.remove("is-open");
        el.style.maxHeight = "0px";
      });
    }
    moOpenIdxRef.current = -1;

    setMoOpen(false);

    // 스크롤 복구
    document.body.classList.remove("no-scroll");
  }, []);

  const toggleMenu = useCallback(() => {
    const wrap = moWrapRef.current;
    if (!wrap) return;

    const willOpen = !wrap.classList.contains("active");
    wrap.classList.toggle("active", willOpen);

    setMoOpen(willOpen);

    // 스크롤 방지/복구
    document.body.classList.toggle("no-scroll", willOpen);

    if (!willOpen) {
      moOpenIdxRef.current = -1;
      const depth2s = wrap.querySelectorAll(".mo_menu_depth2");
      depth2s.forEach((el) => {
        el.classList.remove("is-open");
        el.style.maxHeight = "0px";
      });
    }
  }, []);

  const userFromStorage = useMemo(() => {
    try {
      const s = localStorage.getItem("user");
      return s ? JSON.parse(s) : null;
    } catch {
      return null;
    }
  }, []);

  useEffect(() => {
    if (!userFromStore) dispatch(hydrateFromStorage());
  }, [userFromStore, dispatch]);

  useEffect(() => {
    closeMenu();
  }, [location.pathname, closeMenu]);

  useEffect(() => {
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, []);

  const user = userFromStore || userFromStorage;
  const username = (user && (user.user_name || user.name || user.username || user.id)) || "用户";
  const token = localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(logout());
    navigate("/login");
  };

  const isLoginPage = location.pathname === "/login";

  const openGnb = useCallback(() => {
    navRef.current?.classList.add("active");
  }, []);
  const closeGnb = useCallback(() => {
    navRef.current?.classList.remove("active");
  }, []);

  const onToggleMobileDepth = useCallback(
    (idx) => {
      const wrap = moWrapRef.current;
      if (!wrap) return;

      const depth2s = Array.from(wrap.querySelectorAll(".mo_menu_depth2"));
      if (depth2s.length === 0) return;

      const prev = moOpenIdxRef.current;

      if (prev === idx) {
        slideClose(depth2s[idx]);
        moOpenIdxRef.current = -1;
        return;
      }

      if (prev >= 0 && depth2s[prev]) slideClose(depth2s[prev]);
      if (depth2s[idx]) slideOpen(depth2s[idx]);

      moOpenIdxRef.current = idx;
    },
    [slideClose, slideOpen]
  );

  return (
    <header>
      <div className="header">
        <h1>
          <Link to="/cn/profiling" onClick={closeMenu}>
            {process.env.REACT_APP_CN_CLINIC_NAME} AI
          </Link>
        </h1>

        {!isLoginPage && (
          <div className="right">
            {/* mobile menu */}
            <div className="mobile_menu">
              <button type="button" onClick={toggleMenu} aria-label={moOpen ? "关闭移动端菜单" : "打开移动端菜单"} aria-expanded={moOpen} className="mo_menu_btn">
                <span className="mo_menu_icon" aria-hidden="true">
                  {moOpen ? <IconClose /> : <IconHamburger />}
                </span>
              </button>

              <div className="mo_menu_wrap" ref={moWrapRef}>
                <div>
                  <ul>
                    <li className="mo_menu_lst">
                      <h3 onClick={() => onToggleMobileDepth(0)}>客户沟通</h3>
                      <ul className="mo_menu_depth2">
                        <li>
                          <Link to="/cn/profiling" onClick={closeMenu}>
                            用户画像
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/review" onClick={closeMenu}>
                            评论回复
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/training-response" onClick={closeMenu}>
                            投诉客户应对
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="mo_menu_lst">
                      <h3 onClick={() => onToggleMobileDepth(1)}>训练/辅导</h3>
                      <ul className="mo_menu_depth2">
                        <li>
                          <Link to="/cn/training" onClick={closeMenu}>
                            训练
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/training-followup" onClick={closeMenu}>
                            训练（后续跟进）
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/simulation" onClick={closeMenu}>
                            模拟
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/education" onClick={closeMenu}>
                            培训聊天机器人
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="mo_menu_lst">
                      <h3 onClick={() => onToggleMobileDepth(2)}>资料</h3>
                      <ul className="mo_menu_depth2">
                        <li>
                          <Link to="/cn/dictionary" onClick={closeMenu}>
                            百科
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/analysis" onClick={closeMenu}>
                            行为类型分析
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="mo_menu_lst">
                      <h3 onClick={() => onToggleMobileDepth(3)}>咨询/运营</h3>
                      <ul className="mo_menu_depth2">
                        <li>
                          <Link to="/cn/charting" onClick={closeMenu}>
                            病历记录助手
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/smalltalk" onClick={closeMenu}>
                            闲聊话题
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/memotalk" onClick={closeMenu}>
                            备忘录&提醒消息助手
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>

                  {token && (
                    <div className="btnbox">
                      <Link to="/cn/user_edit" onClick={closeMenu}>
                        <span>{username} 已登录</span>
                      </Link>
                      <button
                        onClick={() => {
                          closeMenu();
                          handleLogout();
                        }}
                        className="btn"
                      >
                        退出登录
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* pc menu */}
            <div className="util" ref={utilRef}>
              <nav ref={navRef} onMouseEnter={openGnb} onMouseLeave={closeGnb}>
                <ul className="depth1_wrap">
                  <li className="depth1">
                    <h3>客户沟通</h3>
                  </li>
                  <li className="depth1">
                    <h3>训练/辅导</h3>
                  </li>
                  <li className="depth1">
                    <h3>资料</h3>
                  </li>
                  <li className="depth1">
                    <h3>咨询/运营</h3>
                  </li>
                </ul>

                <div className="depth2_wrap">
                  <div className="lst">
                    <div className="depth2">
                      <ul>
                        <li>
                          <Link to="/cn/profiling" onClick={closeMenu}>
                            用户画像
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/review" onClick={closeMenu}>
                            评论回复
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/training-response" onClick={closeMenu}>
                            投诉客户应对
                          </Link>
                        </li>
                      </ul>
                    </div>

                    <div className="depth2">
                      <ul>
                        <li>
                          <Link to="/cn/training" onClick={closeMenu}>
                            训练
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/training-followup" onClick={closeMenu}>
                            训练（后续跟进）
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/simulation" onClick={closeMenu}>
                            模拟
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/education" onClick={closeMenu}>
                            培训聊天机器人
                          </Link>
                        </li>
                      </ul>
                    </div>

                    <div className="depth2">
                      <ul>
                        <li>
                          <Link to="/cn/dictionary" onClick={closeMenu}>
                            百科
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/analysis" onClick={closeMenu}>
                            行为类型分析
                          </Link>
                        </li>
                      </ul>
                    </div>

                    <div className="depth2">
                      <ul>
                        <li>
                          <Link to="/cn/charting" onClick={closeMenu}>
                            病历记录助手
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/smalltalk" onClick={closeMenu}>
                            闲聊话题
                          </Link>
                        </li>
                        <li>
                          <Link to="/cn/memotalk" onClick={closeMenu}>
                            备忘录&提醒消息助手
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </nav>

              {token && (
                <div className="btnbox">
                  <Link to="/cn/user_edit" onClick={closeMenu}>
                    <span>{username} 已登录</span>
                  </Link>
                  <button
                    onClick={() => {
                      closeMenu();
                      handleLogout();
                    }}
                    className="btn"
                  >
                    退出登录
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
